import React from 'react'

import { Typography } from '@telavita-core/react-design-kit'

import { Container, Header, Content } from './styles'

interface GraphicsCardProps {
  title: string | JSX.Element
  children: JSX.Element
  headerAction?: JSX.Element
}

export function GraphicsCard({
  title,
  children,
  headerAction,
}: GraphicsCardProps): JSX.Element {
  return (
    <Container>
      <Header>
        <Typography
          variant='content1'
          weight='bolder'
        >
          {title}
        </Typography>
        {headerAction}
      </Header>

      <Content>
        {children}
      </Content>
    </Container>
  )
}